import { jsxs as c, jsx as l } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M37.346 32.844c0-.931-.238-1.806-.657-2.568l10.03-10.03-2.122-2.12-10.03 10.028a5.346 5.346 0 1 0 2.778 4.69ZM32 35.19a2.348 2.348 0 0 1-2.346-2.346A2.349 2.349 0 0 1 32 30.498a2.349 2.349 0 0 1 2.346 2.346A2.348 2.348 0 0 1 32 35.19Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32 11.197a21.703 21.703 0 0 1 15.448 6.399 21.703 21.703 0 0 1 6.398 15.448 22.2 22.2 0 0 1-.159 2.656c1.35.832 2.539 1.9 3.508 3.15.43-1.883.651-3.828.651-5.806 0-6.904-2.688-13.395-7.57-18.276C45.394 9.885 38.904 7.197 32 7.197s-13.395 2.688-18.276 7.57c-4.882 4.881-7.57 11.372-7.57 18.276 0 4.156.975 8.163 2.816 11.759h4.61a21.698 21.698 0 0 1-3.427-11.76 21.703 21.703 0 0 1 6.4-15.447A21.703 21.703 0 0 1 32 11.197Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.874 35.748c-6.145 0-11.126 4.981-11.126 11.126S40.729 58 46.874 58 58 53.02 58 46.874s-4.981-11.126-11.126-11.126Zm0 19.252c-4.48 0-8.126-3.645-8.126-8.126 0-4.48 3.645-8.126 8.126-8.126 4.48 0 8.126 3.645 8.126 8.126C55 51.354 51.355 55 46.874 55Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m47.896 50.224-2.647.703.703 2.646 2.646-.702-.702-2.647ZM47.081 40.359c-2.628 0-4.194 1.782-4.194 3.888 0 .234.018.504.072.756l2.52.09c-.018-.072-.054-.252-.054-.666 0-.846.612-1.692 1.657-1.692 1.08 0 1.602.684 1.602 1.386 0 .468-.162.9-.648 1.26l-.919.684c-1.025.775-1.368 1.693-1.368 2.539 0 .288.018.54.072.792h2.143c0-.81.432-1.278 1.062-1.746l.684-.504c1.08-.793 1.746-1.8 1.746-3.24 0-1.801-1.458-3.547-4.375-3.547Z"
        }
      )
    ]
  }
);
export {
  t as EstimatedCharge
};
